import { WidgetUserTypeEnum } from '../models/widget-user-type.enum';
import { WidgetConfig } from 'src/app/widget-config/initial-config';

export class WidgetStateModel {
    userType: WidgetUserTypeEnum;
    authenticating: boolean;
    authenticated: boolean;
    widgetConfig: WidgetConfig;
    parentUrl: {
        full: string,
        domain: string
    };
    embedded: boolean;
    engineVersion: string;
    engineAPIVersion: string;

    inputEnabled: boolean;
}
